import { type Table } from '@tanstack/react-table';
import { type ReactElement } from 'react';
import {
  Pagination as PaginationComponent,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@avanta/shared/components/ui/Pagination';
import { useTablePagination } from './useTablePagination';

export const Pagination = <T,>({ table }: { table: Table<T> }): ReactElement | null => {
  const {
    canNextPage,
    canPreviousPage,
    currentPage,
    pageNumbers,
    nextPage,
    previousPage,
    setPageIndex,
  } = useTablePagination({ table });

  if (pageNumbers.length <= 1) return null;

  return (
    <PaginationComponent className="mt-3">
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious onClick={previousPage} disabled={!canPreviousPage} />
        </PaginationItem>
        {pageNumbers.map((page, index) => {
          if (page === 'ellipsis') {
            return (
              <PaginationItem key={`ellipsis-${index}`}>
                <PaginationEllipsis />
              </PaginationItem>
            );
          }
          return (
            <PaginationItem key={page}>
              <PaginationLink
                onClick={() => setPageIndex(page - 1)}
                isActive={currentPage === page}
              >
                {page}
              </PaginationLink>
            </PaginationItem>
          );
        })}
        <PaginationItem>
          <PaginationNext onClick={nextPage} disabled={!canNextPage} />
        </PaginationItem>
      </PaginationContent>
    </PaginationComponent>
  );
};
